export default __webpack_public_path__ + "static/media/carouselPreganncyLogoWhite.4edbdeb2.png";